import script from "./MyIconButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyIconButton.vue?vue&type=script&lang=ts&setup=true"

import "./MyIconButton.vue?vue&type=style&index=0&id=cc5ba074&lang=css"

const __exports__ = script;

export default __exports__